import { render } from "./MFAVerify.vue?vue&type=template&id=04281628&scoped=true&ts=true&lang=pug"
import script from "./MFAVerify.vue?vue&type=script&lang=ts"
export * from "./MFAVerify.vue?vue&type=script&lang=ts"

import "./MFAVerify.vue?vue&type=style&index=0&id=04281628&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./MFAVerify.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/views/mfaVerify.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FMFAVerify.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04281628"]])

export default __exports__